import {formatDisplayPrice} from "../../../res/dataServices/pricing";
import './discount.css'
import {getDiscountName, getDiscountValue} from "../calculator/discountDetail";
import {DiscountDetail} from "./discountDetail";

const DiscountRuleDisplay = ({ product }) => {

    const applied = DiscountDetail.sortDiscounts(product.getApplied());
    const unmet = DiscountDetail.getGroupedList(product.getUnmet());
    const uom = product.getSelectedUom();
    const uomSize = product.getSelectedUomSize();

    const hasSavings = applied.length > 0;
    const hasUnmet = unmet.length > 0;
    const unmetText = hasSavings ? "Unlock more savings!" : "You can save!";

    const unitBreakDiscount = ((applied?.find(a => a.type === 'BR')?.discount) ?? 0) * uomSize

    const totalSaving = product.getTotalDiscount() + unitBreakDiscount;
    const bestPrice = (product.getStdPrice() - product.getBestDiscount()) * uomSize;

    if(!hasSavings && !hasUnmet) return;

    return (
        <div className="discount-rule-display">
            {hasSavings &&
                <div className="discount-rule-section">
                    <p className="discount-header">Savings Applied</p>
                    {applied.map((r,i) =>
                        <div key={i} className="discount-rule-container applied-discount">
                            <p>{DiscountDetail.getRuleName(r, uom)}</p>
                            <p className="discount-rule-price">
                                {formatDisplayPrice((r.discount * uomSize))}
                            </p>
                        </div>
                    )}
                    <div className="discount-rule-container applied-discount discount-rule-summary">
                        <p>Total Savings: </p>
                        <p className="discount-rule-price">{formatDisplayPrice(totalSaving)}</p>
                    </div>
                </div>
            }
            {hasUnmet &&
                <div className="discount-rule-section">
                    <p className="discount-header">{unmetText}</p>
                    {unmet.map((rules,k) =>
                        <div key={k}>
                            <div className="discount-rule-container applied-discount">
                                <p>{getDiscountName(rules.type)}</p>
                            </div>
                            {rules.rules.map((r, k2) =>
                                <div key={k2} className="discount-rule-container applied-discount">
                                    <p style={{marginLeft: 12}}>{getDiscountValue(r)}</p>
                                    <p className="discount-rule-price">{formatDisplayPrice(r.discount * uomSize)}</p>
                                </div>
                            )}
                        </div>

                    )}
                    <div className="discount-rule-container unmet discount-rule-summary">
                        <p>Best Price: </p>
                        <p className="discount-rule-price">{formatDisplayPrice(bestPrice)}</p>
                    </div>
                </div>
            }
        </div>
    )

}

export default DiscountRuleDisplay;